<script>
import { mapActions, mapGetters } from "vuex";

import appConfig from "@/app.config.json";
import useVuelidate from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import AuthLayer from "@/router/views/account/AuthLayer";

/**
 * Login-2 component
 */
export default {
  components: {AuthLayer},
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations () {
    return {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    }
  },
  computed: {
    ... mapGetters({
      authLoading: 'authentication/authLoading',
      authErrors: 'authentication/authErrors'
    })
  },
  methods: {
    ... mapActions({
      loginUser: 'authentication/loginUser'
    }),
    async tryToLogIn() {
      this.submitted = true;

      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      await this.loginUser({email: this.email, password: this.password}).then(()=>{
        if(Object.keys(this.$route.query).length > 0){
          this.$router.push(this.$route.query.redirectFrom)
        }else{
          this.$router.push('/dashboard')
        }
      })

      this.v$.$touch();

    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <AuthLayer>
    <div>
      <div class="mb-5">
        <h1 class="text-primary">Welcome back !</h1>
      </div>
      <b-alert
          v-model="isAuthError"
          variant="danger"
          class="mt-3"
          dismissible
      >{{ authError }}</b-alert
      >

      <div class="mt-5">
        <form>
          <b-form-group
              class="mb-3 h4"
              id="input-group-1"
              label="Email"
              label-for="input-1"
          >
            <b-form-input
                id="input-1"
                size="lg"
                v-model="email"
                type="text"
                placeholder="Enter email"
                class="py-3"
                :class="{
                            'is-invalid': submitted && v$.email.$error,
                          }"
            ></b-form-input>
            <p
                v-for="error of v$.email.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </b-form-group>
          <b-form-group
              class="mb-3 h4"
              id="input-group-2"
              label="Password"
              label-for="input-2"
          >
            <b-form-input
                id="input-2"
                size="lg"
                v-model="password"
                type="password"
                placeholder="Enter password"
                class="py-3"
                :class="{
                            'is-invalid': submitted && v$.password.$error,
                          }"
            ></b-form-input>
            <p
                v-for="error of v$.password.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </b-form-group>

          <div v-for="(error, index) in authErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>

          <div class="mt-3 d-grid">
            <b-button variant="primary" size="lg" disabled v-if="authLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button v-else variant="primary" size="lg" class="py-3 h3 text-white" @click="tryToLogIn">Log In</b-button>
          </div>

        </form>
        <div class="mt-5 float-end">
          <p>
            <router-link
                to="/forgot-password"
                class="fw-medium text-success h5"
            >
              Forgot Password/Change Password
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </AuthLayer>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
